import { createContext } from 'react';
const initialAuthState = {
    requiresAuth: false,
    loggedIn: false,
    updateLoggedIn: () => { }
};
const AuthContext = createContext(initialAuthState);
export default AuthContext;
//# sourceMappingURL=AuthContext.js.map